


















































































































































































import Vue from 'vue';
import {Action, Getter} from 'vuex-class';
import {Component, Watch} from 'vue-property-decorator';

import {Brand, Model, tabs, Tag, VehicleTypeOriginRange, vehicleTypes} from '@/modules/neovehicle/models';
import {ActionTypes, GetterTypes} from '@/modules/neovehicle/store/types';
import {
  ClassificationModelFilter,
  FamilyFilter,
  FamilyGroupFilter,
  FamilyVersionFilter,
} from '@/modules/neovehicle/models/filters';
import {CountryEnum} from '@/models/Enums';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import BtnContentOptions from '@/modules/neovehicle/components/btn-content-options.component.vue';
import DataTableModel from '@/modules/neovehicle/components/datatable-model.component.vue';
import DataTableFamilyVersion from '@/modules/neovehicle/components/datatable-version.component.vue';
import DataTableFamily from '@/modules/neovehicle/components/datatable-family.component.vue';
import DataTableFamilyGroup from '@/modules/neovehicle/components/datatable-group.component.vue';
import DialogConfirm from '@/modules/neovehicle/components/dialog-confirm.component.vue';
import DialogFamilyEdit from '@/modules/neovehicle/components/dialog-family-edit.component.vue';
import DialogModelMove from '@/modules/neovehicle/components/dialog-model-move.component.vue';
import DialogFamilyVersionMove from '@/modules/neovehicle/components/dialog-family-version-move.component.vue';
import DialogFamilyMove from '@/modules/neovehicle/components/dialog-family-move.component.vue';
import DialogFamilyGroupCreate from '@/modules/neovehicle/components/dialog-family-group-create.component.vue';
import DialogFamilyCreate from '@/modules/neovehicle/components/dialog-family-create.component.vue';

import {
  FamiliesToFamilyGroupEdit,
  FamilyEdit, FamilyGroupEdit,
  FamilyGroupManagement,
  FamilyManagement,
  FamilyModelEdit,
  FamilyVersionEdit,
  FamilyVersionFamiliesEdit,
  FamilyVersionManagement,
  FamilyVersionModelsEdit,
  FamilyGroupCreateModel, FamilyCreateModel,
} from '@/modules/neovehicle/models/family';
import {differenceBy, remove, uniq} from 'lodash';
import {DataTableModelEnum, EditFamilyTypeEnum} from '@/modules/neovehicle/models/enums';
import {GET_LOGGED_USER} from '@/modules/home/store';
import {IAuthUser} from '@/modules/home/models';
import { SocialClass } from '@/modules/neovehicle/models/socialClass';

@Component({
  components: {
    DialogFamilyGroupCreate,
    BtnContentOptions,
    DataTableModel,
    DataTableFamilyVersion,
    DataTableFamily,
    DataTableFamilyGroup,
    DialogConfirm,
    DialogFamilyEdit,
    DialogModelMove,
    DialogFamilyVersionMove,
    DialogFamilyMove,
    DialogFamilyCreate,
  },
})
export default class extends Vue {
  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected!: CountryEnum;

  @Getter(GetterTypes.GET_MODELS)
  public models: Model[];

  @Getter(GetterTypes.GET_VEHICLE_TYPE_ORIGINS_RANGE)
  public vehicleTypeOriginsRange: VehicleTypeOriginRange[];

  @Getter(GetterTypes.GET_BRANDS)
  public brands: Brand[];

  @Getter(GetterTypes.GET_FAMILY_VERSIONS_MANAGEMENT)
  public versions: FamilyVersionManagement[];

  @Getter(GetterTypes.GET_FAMILIES_MANAGEMENT)
  public families: FamilyManagement[];

  @Getter(GetterTypes.GET_FAMILY_GROUPS_MANAGEMENT)
  public groups: FamilyGroupManagement[];

  @Getter(GET_LOGGED_USER)
  public authUser: IAuthUser;

  @Getter(GetterTypes.GET_TAGS_BY_FAMILY_CONTEXT)
  public tagsByFamily: Tag[];

  @Getter(GetterTypes.GET_SOCIAL_CLASSES)
  public socialClasses: SocialClass[];

  @Action(ActionTypes.FETCH_SOCIAL_CLASSES)
  public fetchSocialClasses: (filter: { country: CountryEnum; }) => Promise<SocialClass[]>;

  @Action(ActionTypes.FETCH_FAMILIES_MANAGEMENT)
  public fetchFamiliesManagement: (filter: FamilyFilter) => Promise<FamilyManagement[]>;

  @Action(ActionTypes.FETCH_FAMILY_VERSIONS_MANAGEMENT)
  public fetchFamilyVersionsManagement: (filter: FamilyVersionFilter) => Promise<FamilyVersionManagement[]>;

  @Action(ActionTypes.DELETE_FAMILY_VERSIONS_MANAGEMENT)
  public deleteFamilyVersion: (familyVersion: FamilyVersionManagement) => Promise<void>;

  @Action(ActionTypes.DELETE_FAMILIES_MANAGEMENT)
  public deleteFamily: (family: FamilyManagement) => Promise<void>;

  @Action(ActionTypes.DELETE_FAMILIES_GROUP_MANAGEMENT)
  public deleteFamilyGroup: (familyGroup: FamilyGroupManagement) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_VERSION_MANAGEMENT)
  public updateFamilyVersion: (familyVersion: FamilyVersionEdit) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_MANAGEMENT)
  public updateFamily: (family: FamilyEdit) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_GROUP_MANAGEMENT)
  public updateFamilyGroup: (familyGroup: FamilyGroupEdit) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_VERSION_MODELS)
  public updateFamilyVersionModels: (edit: FamilyVersionModelsEdit) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_FROM_VERSIONS)
  public updateFamilyFromVersions: (edit: FamilyVersionFamiliesEdit) => Promise<void>;

  @Action(ActionTypes.UPDATE_FAMILY_GROUP_FROM_FAMILIES)
  public updateFamilyGroupFromFamilies: (edit: FamiliesToFamilyGroupEdit) => Promise<void>;

  @Action(ActionTypes.FETCH_FAMILY_GROUPS_MANAGEMENT)
  public fetchFamilyGroupsManagement: (filter: FamilyGroupFilter) => Promise<FamilyGroupManagement[]>;

  @Action(ActionTypes.UPDATE_MODEL_CLASSIFICATION_SELECTED)
  public setModelClassificationSelected: (model: Model[] | null) => void;

  @Action(ActionTypes.UPDATE_MODEL_EDIT_SELECTED)
  public setModelEditSelected: (model: Model[] | null) => void;

  @Action(ActionTypes.FETCH_BRANDS)
  public fetchBrands: () => Promise<Brand[]>;

  @Action(ActionTypes.FETCH_MODELS)
  public fetchModels: (filter: ClassificationModelFilter) => Promise<Model[]>;

  @Action(ActionTypes.FETCH_MODELS_EXPORT)
  public fetchModelsExport: (country: CountryEnum) => Promise<any>;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public setCurrentTab: (selected: string) => void;

  @Action(ActionTypes.CLEAR_STORE)
  public clearStore: () => void;

  @Action(ActionTypes.FETCH_VEHICLE_TYPE_ORIGINS_RANGE)
  public fetchVehicleTypeOriginsRange: () => Promise<VehicleTypeOriginRange[]>;

  @Action(ActionTypes.INSERT_FAMILY_GROUP)
  public insertFamilyGroup: (familyGroup: FamilyGroupCreateModel) => Promise<boolean>;

  @Action(ActionTypes.INSERT_FAMILY)
  public insertFamily: (family: FamilyCreateModel) => Promise<boolean>;

  public isLoading = true;
  public country = CountryEnum;
  public dataTableModelEnum = DataTableModelEnum;

  public classificationModelFilter!: ClassificationModelFilter;
  public familyVersionFilter!: FamilyVersionFilter;
  public familyFilter!: FamilyFilter;
  public familyGroupFilter!: FamilyGroupFilter;
  public modelsSelected: Model[] = [];
  public versionsSelected: FamilyVersionManagement[] = [];
  public familiesSelected: FamilyManagement[] = [];


  public familyVersionDelete: FamilyVersionManagement | null = null;
  public familyDelete: FamilyManagement | null = null;
  public familyGroupDelete: FamilyGroupManagement | null = null;

  public currentFamilyEdit: FamilyModelEdit | null = null;
  public currentFamilyVersion: any = null;
  public typeFamilyEdit: EditFamilyTypeEnum = EditFamilyTypeEnum.FamilyVersion;

  public openDialogModelMove: boolean = false;
  public openDialogFamilyVersionMove: boolean = false;
  public openDialogFamilyMove: boolean = false;
  public openDialogFamilyGroupCreateModel: boolean = false;
  public openDialogFamilyCreateModel: boolean = false;

  public vehicleTypesSearch = Object.keys(vehicleTypes).map((key: any) => ({
    id: key,
    name: vehicleTypes[key].name,
  }));

  public familyEditUpdateAction: any = null;

  @Action(ActionTypes.FETCH_TAGS_BY_FAMILY_CONTEXT)
  private fetchTags: () => Promise<Tag[]>;

  public handleSearchModel() {
    this.loadModels();
  }

  public get isLatam() {
    return this.countrySelected !== CountryEnum.Brasil;
  }

  @Watch('countrySelected')
  public changeCountry(selected: CountryEnum) {
    this.classificationModelFilter = {
      isClassified: this.classificationModelFilter.isClassified,
      country: selected,
    };
    this.familyVersionFilter.country = selected;
    this.familyFilter.country = selected;
    this.familyGroupFilter.country = selected;
    (this.$refs.tabModel as any).click();

    this.loadModels();
    this.fetchSocialClasses({ country: selected });
  }

  public changeClassified() {
    this.classificationModelFilter = {
      isClassified: this.classificationModelFilter.isClassified,
      country: this.classificationModelFilter.country,
    };
    this.resetSelectedModels();
    this.handleSearchModel();
  }

  public loadModels() {
    this.isLoading = true;
    this.fetchModels(this.classificationModelFilter).then(
      () => (this.isLoading = false),
    );
  }

  public handleDownload() {
    this.isLoading = true;
    this.fetchModelsExport(this.countrySelected)
      .catch((err: any) => console.log(err))
      .finally(() => (this.isLoading = false));
  }

  public created() {
    this.clearStore();

    this.familyEditUpdateAction = {
      [EditFamilyTypeEnum.FamilyVersion]: async (familyEdit: FamilyModelEdit) => {
        const update: FamilyVersionEdit = {
          idFamilyVersion: familyEdit.id,
          idFamily: familyEdit.idFamily!,
          idFamilyNew: familyEdit.idFamilyNew!,
          familyVersionName: familyEdit.name,
          idUser: this.authUser.iduser,
          marketValue: familyEdit.marketValue!,
          marketValueReference: familyEdit.marketValueReference!,
        };

        await this.updateFamilyVersion(update);
        await this.fetchFamilyVersionsManagement(this.familyVersionFilter);
      },
      [EditFamilyTypeEnum.Family]: async (familyEdit: FamilyModelEdit) => {
        const update: FamilyEdit = {
          idFamily: familyEdit.id,
          idFamilyGroup: familyEdit.idFamilyGroup!,
          idFamilyGroupNew: familyEdit.idFamilyGroupNew!,
          familyName: familyEdit.name,
          idUser: this.authUser.iduser,
          idSocialClass: familyEdit.idSocialClass,
        };

        await this.updateFamily(update);
        await this.fetchFamiliesManagement(this.familyFilter);
      },
      [EditFamilyTypeEnum.FamilyGroup]: async (familyGroupEdit: FamilyModelEdit) => {
        const update: FamilyGroupEdit = {
          idFamilyGroup: familyGroupEdit.id,
          familyGroupName: familyGroupEdit.name,
          idUser: this.authUser.iduser,
        };

        await this.updateFamilyGroup(update);
        await this.fetchFamilyGroupsManagement(this.familyGroupFilter);
      },
    };

    this.classificationModelFilter = {
      isClassified: false,
      country: this.countrySelected,
    };

    this.familyVersionFilter = {
      country: this.countrySelected,
    };

    this.familyFilter = {
      country: this.countrySelected,
    };

    this.familyGroupFilter = {
      country: this.countrySelected,
    };

    this.loadModels();
    this.fetchSocialClasses({ country: this.countrySelected });
    this.fetchBrands();
    this.fetchVehicleTypeOriginsRange();
  }

  public destroy() {
    this.clearStore();
  }

  public handleFormModel(edit: boolean, model: Model): void {
    if (edit) {
      this.setModelClassificationSelected(null);
      this.setModelEditSelected([model]);
    } else {
      this.setModelClassificationSelected([model]);
      this.setModelEditSelected(null);
    }

    this.$router.push('model/form');
    this.setCurrentTab(tabs.form);
  }

  public handleFormModels(edit: boolean): void {
    if (edit) {
      this.setModelClassificationSelected(null);
      this.setModelEditSelected(this.modelsSelected);
    } else {
      this.setModelClassificationSelected(this.modelsSelected);
      this.setModelEditSelected(null);
    }

    this.$router.push('model/form');
    this.setCurrentTab(tabs.form);
  }

  public async handleTab(dataTableModelEnum: DataTableModelEnum) {
    const fetch = {
      [DataTableModelEnum.FamilyGroup]: async () => await this.fetchFamilyGroupsManagement(this.familyGroupFilter),
      [DataTableModelEnum.Family]: async () => await this.fetchFamiliesManagement(this.familyFilter),
      [DataTableModelEnum.FamilyVersion]: async () => await this.fetchFamilyVersionsManagement(this.familyVersionFilter),
      [DataTableModelEnum.Model]: async () => await this.fetchModels(this.classificationModelFilter),
    };

    this.isLoading = true;
    await fetch[dataTableModelEnum]();
    this.resetSelectedModels();

    this.isLoading = false;
  }

  public handleOpenDeleteFamilyVersion(familyVersion: FamilyVersionManagement) {
    this.familyVersionDelete = familyVersion;
  }

  public async handleRemoveFamilyVersion() {
    await this.deleteFamilyVersion(this.familyVersionDelete!);
    await this.fetchFamilyVersionsManagement(this.familyVersionFilter);
    this.familyVersionDelete = null;
  }

  public handleOpenDeleteFamily(family: FamilyManagement) {
    this.familyDelete = family;
  }

  public async handleRemoveFamily() {
    await this.deleteFamily(this.familyDelete!);
    await this.fetchFamiliesManagement(this.familyFilter);
    this.familyDelete = null;
  }

  public handleOpenDeleteFamilyGroup(familyGroup: FamilyGroupManagement) {
    this.familyGroupDelete = familyGroup;
  }

  public handleOpenCreateGroup() {
    this.openDialogFamilyGroupCreateModel = true;
  }

  public async handleOpenCreateFamily() {
    this.isLoading = true;
    this.familyGroupFilter = {
      country: this.countrySelected,
    };
    await this.fetchFamilyGroupsManagement(this.familyGroupFilter);
    await this.fetchTags();
    this.openDialogFamilyCreateModel = true;
    this.isLoading = false;
  }


  public async handleRemoveFamilyGroup() {
    await this.deleteFamilyGroup(this.familyGroupDelete!);
    await this.fetchFamilyGroupsManagement(this.familyGroupFilter);
    this.familyGroupDelete = null;
  }

  public handleSelectModel(modelsSelected: Model[]) {
    this.modelsSelected = this.getUniqSelected(this.modelsSelected, modelsSelected, 'id');
  }

  public handleSelectFamilyVersion(versionsSelected: FamilyVersionManagement[]) {
    this.versionsSelected = this.getUniqSelected(this.versionsSelected, versionsSelected, 'idFamilyVersion');
  }

  public handleSelectFamily(versionsSelected: FamilyManagement[]) {
    this.familiesSelected = this.getUniqSelected(this.versionsSelected, versionsSelected, 'idFamily');
  }

  public getUniqSelected(selected: any, data: any, key: string) {
    const removed = differenceBy(selected, data, key);
    let result = selected.concat(data);
    result = remove(result, (f: any) => !removed.some((m: any) => m[key] === f[key]));
    result = uniq(result);

    return result.filter((x: any) => !!x);
  }

  public handleCloseDialog() {
    this.familyVersionDelete = null;
    this.familyDelete = null;
    this.familyGroupDelete = null;
  }

  public async handleFamilyVersionEdit(familyVersion: FamilyVersionManagement) {
    this.isLoading = true;

    this.typeFamilyEdit = EditFamilyTypeEnum.FamilyVersion;

    this.familyFilter.idBrand = familyVersion.idBrand;
    await this.fetchFamiliesManagement(this.familyFilter);

    this.familyGroupFilter.idBrand = familyVersion.idBrand;
    await this.fetchFamilyGroupsManagement(this.familyGroupFilter);

    this.currentFamilyEdit = {
      id: familyVersion.idFamilyVersion,
      name: familyVersion.familyVersionName,
      idFamily: familyVersion.idFamily,
      idFamilyGroup: familyVersion.idFamilyGroup,
      idFamilyNew: familyVersion.idFamily,
      idFamilyGroupNew: familyVersion.idFamilyGroup,
      idBrand: familyVersion.idBrand,
      marketValue: familyVersion.marketValue,
      marketValueReference: familyVersion.marketValueReference,
    };

    this.isLoading = false;
  }

  public async handleFamilyEdit(family: FamilyManagement) {
    this.isLoading = true;

    this.typeFamilyEdit = EditFamilyTypeEnum.Family;

    this.familyGroupFilter.idBrand = family.idBrand;
    await this.fetchFamilyGroupsManagement(this.familyGroupFilter);

    this.currentFamilyEdit = {
      id: family.idFamily,
      name: family.familyName,
      idFamily: family.idFamily,
      idFamilyGroup: family.idFamilyGroup,
      idFamilyNew: family.idFamily,
      idFamilyGroupNew: family.idFamilyGroup,
      idSocialClass: family.idSocialClass,
    };

    this.isLoading = false;
  }

  public async handleFamilyGroupEdit(familyGroup: FamilyGroupManagement) {
    this.isLoading = true;

    this.typeFamilyEdit = EditFamilyTypeEnum.FamilyGroup;

    this.currentFamilyEdit = {
      id: familyGroup.idFamilyGroup,
      name: familyGroup.familyGroupName,
    };

    this.isLoading = false;
  }

  public async updateFamilyVersionEdit(familyEdit: FamilyModelEdit) {
    this.isLoading = true;

    await this.familyEditUpdateAction[this.typeFamilyEdit](familyEdit);

    this.currentFamilyEdit = null;
    this.isLoading = false;
  }

  public handleCancelFamilyEdit() {
    this.currentFamilyEdit = null;
    this.resetSelectedModels();
  }

  public async handleMoveModels() {
    const allModelsSameBrand = this.modelsSelected
      .reduce((acc, curr) => {
        acc.add(curr.brand.id);
        return acc;
      }, new Set())
      .size === 1;

    if (allModelsSameBrand) {
      this.openDialogModelMove = true;
      this.familyVersionFilter.idBrand = this.modelsSelected[0].brand.id;
      await this.fetchFamilyVersionsManagement(this.familyVersionFilter);
    } else {
      alert('Somente é possível mover modelos de uma mesma bandeira.');
      return;
    }
  }

  public async handleMoveFamilyVersions() {
    const allFamiliesVersionSameBrand = this.versionsSelected
      .reduce((acc, curr) => {
        acc.add(curr.idBrand);
        return acc;
      }, new Set())
      .size === 1;

    if (allFamiliesVersionSameBrand) {
      this.openDialogFamilyVersionMove = true;
      this.familyFilter = {
        country: this.countrySelected,
      };
      this.familyFilter.idBrand = this.versionsSelected[0].idBrand;
      await this.fetchFamiliesManagement(this.familyFilter);
    } else {
      alert('Somente é possível mover famílias versão de uma mesma bandeira.');
      return;
    }
  }

  public async handleMoveFamilies() {
    const allFamiliesSameBrand = this.familiesSelected
      .reduce((acc, curr) => {
        acc.add(curr.idBrand);
        return acc;
      }, new Set())
      .size === 1;

    if (allFamiliesSameBrand) {
      this.openDialogFamilyMove = true;
      this.familyGroupFilter = {
        country: this.countrySelected,
      };
      this.familyGroupFilter.idBrand = this.familiesSelected[0].idBrand;
      await this.fetchFamilyGroupsManagement(this.familyGroupFilter);
    } else {
      alert('Somente é possível mover famílias de uma mesma bandeira.');
      return;
    }
  }

  public handleCancelModelMove() {
    this.openDialogModelMove = false;
  }

  public handleCancelFamilyVersionMove() {
    this.openDialogFamilyVersionMove = false;
  }

  public handleCancelFamilyMove() {
    this.openDialogFamilyMove = false;
  }

  public handleCancelFamilyGroupCreate() {
    this.openDialogFamilyGroupCreateModel = false;
  }

  public handleCancelFamilyCreate() {
    this.openDialogFamilyCreateModel = false;
  }

  public async handleMoveSelectedModelsToVersion(idFamilyVersion: number) {
    const update: FamilyVersionModelsEdit = {
      idFamilyVersionNew: idFamilyVersion,
      idModels: this.modelsSelected.map((x: Model) => x.id),
      isAllModels: false,
      idUser: this.authUser.iduser,
    };

    await this.updateFamilyVersionModels(update);

    this.openDialogModelMove = false;
    this.resetSelectedModels();
    await this.fetchModels(this.classificationModelFilter);
  }

  public async handleMoveSelectedVersionsToFamily(idFamily: number) {
    const update: FamilyVersionFamiliesEdit = {
      idFamilyNew: idFamily,
      idFamilyVersions: this.versionsSelected.map((x: FamilyVersionManagement) => x.idFamilyVersion),
      idUser: this.authUser.iduser,
    };

    await this.updateFamilyFromVersions(update);

    this.openDialogFamilyVersionMove = false;
    this.resetSelectedFamilyVersions();
    await this.fetchFamilyVersionsManagement(this.familyVersionFilter);
  }

  public async handleMoveSelectedFamiliesToFamilyGroup(idFamilyGroup: number) {
    const update: FamiliesToFamilyGroupEdit = {
      idFamilyGroupNew: idFamilyGroup,
      idFamilies: this.familiesSelected.map((x: FamilyManagement) => x.idFamily),
      idUser: this.authUser.iduser,
    };

    await this.updateFamilyGroupFromFamilies(update);

    this.openDialogFamilyMove = false;
    this.resetSelectedFamilies();
    await this.fetchFamiliesManagement(this.familyFilter);
  }

  public async handleMoveAllModels(familyModelEdit: FamilyModelEdit) {
    this.isLoading = true;

    this.familyVersionFilter.idBrand = familyModelEdit.idBrand;
    await this.fetchFamilyVersionsManagement(this.familyVersionFilter);

    this.openDialogModelMove = true;

    this.currentFamilyVersion = {
      idFamilyVersion: familyModelEdit.id,
      familyVersionName: familyModelEdit.name,
    };

    this.isLoading = false;
  }

  public async handleMoveAllModelsToVersion(currentFamilyVersion: {idFamilyVersion: number}, idFamilyVersion: number) {
    const update: FamilyVersionModelsEdit = {
      idFamilyVersionNew: idFamilyVersion,
      idFamilyVersion: currentFamilyVersion.idFamilyVersion,
      idModels: [],
      isAllModels: true,
      idUser: this.authUser.iduser,
    };

    await this.updateFamilyVersionModels(update);

    this.openDialogModelMove = false;
    this.currentFamilyVersion = null;
    this.currentFamilyEdit = null;
    this.resetSelectedModels();
    await this.fetchModels(this.classificationModelFilter);
    await this.fetchFamilyVersionsManagement(this.familyVersionFilter);
  }

  public async handleSaveFamilyGroupCreate(familyGroup: FamilyGroupCreateModel) {
    this.isLoading = true;

    familyGroup.country = this.countrySelected;
    await this.insertFamilyGroup(familyGroup);
    await this.fetchFamilyGroupsManagement(this.familyGroupFilter);
    this.handleCancelFamilyGroupCreate();

    this.isLoading = false;
  }

  public async handleSaveFamilyCreate(family: FamilyCreateModel) {
    this.isLoading = true;

    family.country = this.countrySelected;
    await this.insertFamily(family);
    await this.fetchFamiliesManagement(this.familyFilter);
    this.handleCancelFamilyCreate();

    this.isLoading = false;
  }

  private resetSelectedModels() {
    this.modelsSelected = [];
    (this.$refs.dataTableModel as any).resetSelect();
  }

  private resetSelectedFamilyVersions() {
    this.versionsSelected = [];
    (this.$refs.dataTableFamilyVersion as any).resetSelect();
  }

  private resetSelectedFamilies() {
    this.familiesSelected = [];
    (this.$refs.dataTableFamily as any).resetSelect();
  }
}
